import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { _ } from 'underscore';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CommercialService } from '../../questionnaire/commercial.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  showLogin = true;
  queryObj = {
    hg_accountId: null,
    type: 'commercial',
  };
  url = environment.api_url;
  constructor(
    private router: Router,
    private http: HttpClient,
    private commercialService: CommercialService
  ) {}

  ngOnInit() {
    const user = sessionStorage.getItem('userObj');
    if (user) {
      this.showLogin = false;
    }
  }
  addClass(e) {
    const elementObj = document.getElementById('menuIcon');
    const navElement = document.getElementById('navbarsExampleDefault');
    const navheadElement = document.getElementById('navbarhead');
    if (navElement.classList.contains('show')) {
      elementObj.classList.remove('listicn');
      elementObj.classList.add('closeicn');
      elementObj['src'] = 'assets/images/list-charcoal.png';
      navheadElement.classList.remove('parent');
    } else {
      elementObj.classList.remove('closeicn');
      elementObj.classList.add('listicn');
      elementObj['src'] = 'assets/images/close-charcoal.svg';
      navheadElement.classList.add('parent');
    }
  }
  mobhead(e) {
    const elementObj = document.getElementById('menuIcon');
    const navElement = document.getElementById('navbarsExampleDefault');
    const navheadElement = document.getElementById('navbarhead');
    if (navElement.classList.contains('show')) {
      elementObj.classList.remove('listicn');
      elementObj.classList.add('closeicn');
      elementObj['src'] = 'assets/images/list.png';
      navElement.classList.remove('show');
      navheadElement.classList.remove('parent');
    }
  }

  gotologout() {
    sessionStorage.clear();
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: this.router.url },
    });
  }

  gotoProfile() {
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      this.showLogin = false;
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if (result.hg_accountId) {
        this.router.navigate(['user-settings', result.hg_accountId]);
      } else {
        this.router.navigate(['user-settings', result._id]);
      }
    }
  }

  navigatee(path) {
    this.router.navigateByUrl(path);
  }

  navigate(param) {
    sessionStorage.clear();
    this.commercialService.addAddress = false;
    this.commercialService.serialNumber = null;
    this.commercialService.messageService({});
    this.commercialService.currentId = '001';
    this.commercialService.userResponse.userResponses = [];
    this.router.navigateByUrl('/commercial/questionnaire');
  }
  mobileHeaderClick(selectedMenu) {
    if (selectedMenu === 'residential') {
      this.router.navigateByUrl('/');
    } else if (selectedMenu === 'giveback') {
      this.router.navigateByUrl('/giveback');
    } else if (selectedMenu === 'faq') {
      sessionStorage.setItem('faqFlag', 'faq');
      sessionStorage.removeItem('contcusFlag');
      this.router.navigateByUrl('/faq');
    } else if (selectedMenu === 'blog') {
      this.router.navigateByUrl('/blog');
    } else if (selectedMenu === 'faq/contact-us') {
      sessionStorage.setItem('contcusFlag', 'contact');
      sessionStorage.removeItem('faqFlag');
      this.router.navigateByUrl('/faq/contact-us');
    } else if (selectedMenu === 'login') {
      this.router.navigateByUrl('/login');
    }
  }
}
